import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import styled from 'styled-components';
import { TwoFactorAuthenticationMethods, } from '@tradingblock/types';
import { Views } from '../TwoFactorAuthentication';
import { validateTwoFactorAuthenticationSecurityCode } from '../../../utilities';
import { FormGroup } from '../../basic';
import { TextboxField } from '../../localize/fields';
import PrimaryButton from '../components/PrimaryButton';
;
;
const StyledEnterSecurityCode = styled.div `
  .form-group {
    margin-bottom: 0;
  }

  .send-new-code-btn, .use-diff-method-btn {
    color: white;
  }

  .btn-wrapper separator {
    color: white;
  }
`;
const EnterSecurityCode = ({ selectedVerifiedTwoFactorAuthenticationMethodData, requestSecurityCode, submitSecurityCode, setCurrentView, primaryBtnText, primaryBtnClassName, PrimaryBtnIcon, primaryBtnIconClassName, plivoUuid, isSubmittingTwoFactorAuthenticationSecurityCode, shouldShowUseDifferentMethodBtn, errorMsg, }) => {
    const [selectedVerifiedTwoFactorAuthenticationMethodContact, setSelectedVerifiedTwoFactorAuthenticationMethodContact] = useState(null);
    useEffect(() => {
        if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms) {
            setSelectedVerifiedTwoFactorAuthenticationMethodContact(selectedVerifiedTwoFactorAuthenticationMethodData.phoneNumber);
        }
        else if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email) {
            setSelectedVerifiedTwoFactorAuthenticationMethodContact(selectedVerifiedTwoFactorAuthenticationMethodData.email);
        }
    }, []);
    useEffect(() => {
        requestSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType);
    }, []);
    const onSubmit = async (values) => {
        const { securityCode } = values;
        if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms) {
            submitSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType, securityCode, plivoUuid || '');
        }
        else if (selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email) {
            submitSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType, securityCode);
        }
    };
    return (React.createElement(StyledEnterSecurityCode, null,
        React.createElement("p", null,
            "We sent a security code to ",
            selectedVerifiedTwoFactorAuthenticationMethodContact,
            "."),
        React.createElement(Formik, { onSubmit: onSubmit, initialValues: { securityCode: '' }, validateOnChange: true, validationSchema: Yup
                .object()
                .shape({
                securityCode: Yup
                    .string()
                    .trim()
                    .test('validityCheck', 'Please enter a valid security code.', (securityCodeString) => validateTwoFactorAuthenticationSecurityCode(securityCodeString)),
            }) },
            React.createElement(Form, { translate: undefined },
                React.createElement(FormGroup, null,
                    React.createElement(Field, { component: TextboxField, id: "securityCode" })),
                React.createElement("div", { className: "mt-1 btn-wrapper" },
                    React.createElement("button", { type: "button", onClick: () => requestSecurityCode(selectedVerifiedTwoFactorAuthenticationMethodData.twoFaType), className: "send-new-code-btn" }, "Resend code"),
                    shouldShowUseDifferentMethodBtn && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "ml-1 mr-1 separator" }, "|"),
                        React.createElement("button", { type: "button", onClick: () => setCurrentView(Views.VerifiedMethodSelection), className: "use-diff-method-btn" }, "Use different method"))),
                    React.createElement(PrimaryButton, { primaryBtnClassName: primaryBtnClassName, btnText: primaryBtnText, btnType: "submit", PrimaryBtnIcon: PrimaryBtnIcon, primaryBtnIconClassName: primaryBtnIconClassName, disabled: isSubmittingTwoFactorAuthenticationSecurityCode })),
                errorMsg && React.createElement("p", { className: "error mt-3" }, errorMsg)))));
};
export default EnterSecurityCode;
//# sourceMappingURL=EnterSecurityCode.js.map